var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{key:_vm.id,staticClass:"base-chart"},[_c('div',{staticClass:"base-chart__chart-container",style:(`min-height: ${_vm.gridStepHeight}px`),attrs:{"id":_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }